import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const MinusOutlinedIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path fillRule="evenodd" transform="translate(5 11)" id="a" d="M13 2H1c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1z" />
  </SvgIcon>
);
